import React from "react";
import Filter from "./filter";
import AcVisto from "./Accordions/ac_vistos";
import AcTaxas from "./Accordions/ac_taxas";
import AcBolsas from "./Accordions/ac_bolsas";
import AcCusto from "./Accordions/ac_custo";
import AcAlojamento from "./Accordions/ac_alojamento";
import AcViver from "./Accordions/ac_viver";
import AcEstudar from "./Accordions/ac_estudar";
import AcVidaacademica from "./Accordions/ac_vidaacademica";
import { withNamespaces } from 'react-i18next';

const FAQ = ({t}) => {
  return (
    <>

      <div className="container  mt-4">
        <div className="row mb-3">
          <div className="col-md-4 mb-3">
          </div>
          <div className="col-md-8">
            <Filter />
          </div>
        </div>
        {/* AREA 1 VISTOS E AUTORIZAÇÃO DE RESIDENCIA */}
        <div id="1" className="fantasmaAncora"></div>
        <div className="row mb-3">
          <div className="col-md-4 mb-3">
            <h2>{t('moduleFaqs:S1.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8 marginB_title">
            <AcVisto />
          </div>
        </div>

        {/* AREA 2 TAXAS DE FREQUÊNCIA E OUTROS CUSTOS */}
        <div id="2" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3">
            <h2>{t('moduleFaqs:S2.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8 marginB_title">
            <AcTaxas />
          </div>
        </div>

        {/* AREA 3 BOLSAS */}
        <div id="3" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3">
            <h2>{t('moduleFaqs:S3.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8 marginB_title">
            <AcBolsas />
          </div>
        </div>

        {/* AREA 4 CUSTO DE VIDA E OUTROS */}
        <div id="4" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3">
            <h2>{t('moduleFaqs:S4.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8 marginB_title">
            <AcCusto />
          </div>
        </div>

        {/* AREA 5 ALOJAMENTO */}
        <div id="5" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3">
            <h2>{t('moduleFaqs:S5.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8 marginB_title">
            <AcAlojamento />
          </div>
        </div>

        {/* AREA 6 VIVER EM AVEIRO E PT */}
        <div id="6" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3">
            <h2>{t('moduleFaqs:S6.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8 marginB_title">
            <AcViver />
          </div>
        </div>

        {/* AREA 7 ESTUDAR EM AVEIRO */}
        <div id="7" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3">
            <h2>{t('moduleFaqs:S7.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8 marginB_title">
            <AcEstudar />
          </div>
        </div>

        {/* AREA 8 VIDA ACADÉMICA */}
        <div id="8" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4 marginB_section">
          <div className="col-md-4 mb-3">
            <h2>{t('moduleFaqs:S8.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8 marginB_title">
            <AcVidaacademica />
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces() (FAQ);
